import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'donationEdit';

const reducersKeys = {
  updateDonateFormRequest: 'updateDonateFormRequest',
  updateDonateFormSuccess: 'updateDonateFormSuccess',
  updateDonateFormFailure: 'updateDonateFormFailure',
  getDonateFormRequest: 'getDonateFormRequest',
  getDonateFormSuccess: 'getDonateFormSuccess',
  getDonateFormFailure: 'getDonateFormFailure',
};

const initialState = {
  donateForm: null,
  loaded: false,
  loading: false,
  error: null,
};

const donateFormEdit = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.updateDonateFormRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
    },
    [reducersKeys.updateDonateFormSuccess]: (state) => {
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.updateDonateFormFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    [reducersKeys.getDonateFormRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
      state.donateForm = null;
    },
    [reducersKeys.getDonateFormSuccess]: (state, { payload }) => {
      state.donateForm = payload.donateForm;
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getDonateFormFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
  },
});

export const donateFormEditReducers = createReducerNames(name, reducersKeys);
export const { actions } = donateFormEdit;

export default donateFormEdit.reducer;
